<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <span><strong>Account: {{account_num}}</strong>, Welcome back {{user_name}}!</span>
      </div>
    </div>
    <div class="animated fadeIn">
      <b-card>
        <div v-html="htmlIFrame">
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>

export default {
  created () {
    this.goToExternalCall()
  },
  data () {
    return {
      account_num: sessionStorage.getItem('account'),
      user_name: sessionStorage.getItem('login'),
      htmlIFrame: '<iframe id="chartIframe" src=' + this.getURL() + ' style="width:100%;height:800px;"></iframe>'
    }
  },
  methods: {
    getURL () {
      if (sessionStorage.getItem('account') === undefined || sessionStorage.getItem('account') === null) return

      if (sessionStorage.getItem('account').toLowerCase().indexOf('demo') === -1) { return 'https://m-webmapplotter-2018.azurewebsites.net/web/barchartaccount/barchartaccount.html?account=' + sessionStorage.getItem('account') } else { return 'https://m-webmapplotter-2018.azurewebsites.net/web/barchart/barchart.html' }
    },
    goToExternalCall () {
      if (localStorage.getItem('externalRunScanParams') !== undefined || localStorage.getItem('externalRunScanParams') != null) {
        let externalScanParams = JSON.parse(localStorage.getItem('externalRunScanParams'))
        localStorage.setItem('PendingScanParam', 'true')
        if (externalScanParams != null && externalScanParams !== undefined && externalScanParams.templateid !== undefined && externalScanParams.app === undefined) {
          this.$router.push('/mGauge/VehicleSampling')
        }
        if (externalScanParams != null && externalScanParams !== undefined && externalScanParams.templateid !== undefined && externalScanParams.app === 'mscope') {
          this.$router.push('/mScope/VehicleSampling')
        }
      }

      if (localStorage.getItem('externalReportHistory') !== undefined || localStorage.getItem('externalReportHistory') != null) {
        let externalScanParams = JSON.parse(localStorage.getItem('externalReportHistory'))

        if (externalScanParams !== null && externalScanParams !== undefined && externalScanParams.report_id !== undefined) {
          this.$router.push('/mGauge/ReportHistory')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue